import { useState } from "react";

export type ViewMode = "card" | "list";

// マスター画面・試薬画面で共通の表示モード。1つの設定を localStorage で共有する。
const STORAGE_KEY = "reagentViewMode";

export function useViewMode(): [ViewMode, (mode: ViewMode) => void] {
  const [mode, setMode] = useState<ViewMode>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "list" ? "list" : "card"; // 既定はカード
  });

  function updateMode(next: ViewMode) {
    localStorage.setItem(STORAGE_KEY, next);
    setMode(next);
  }

  return [mode, updateMode];
}
